/** The permission codes the Custom Pay Run screens use to hide or disable controls. Display only: the server enforces each one. */
export const CPR_PERMISSIONS = {
  read: 'custompayruns.read',
  write: 'custompayruns.write',
  approveRun: 'payrollruns.approve',
} as const;

export const NO_PERMISSION_NOTE = 'Your role does not allow this. Ask an administrator.';
